import React from "react";
import { PatientTaskInstanceDocument } from "../../../messages";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { CHEVRON_RIGHT_ICON } from "../../../utils/svgs_new";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "../../Generic/AppCard";
import { AppIcon } from "../../Generic/AppIcon";
import { AppList, AppListItem } from "../../Generic/AppList";

interface Props {
  documents: PatientTaskInstanceDocument[];
}

const AvailableTaskRequiredDocuments = (props: Props) => {
  return (
    <AppCard>
      <AppCardHeader>
        <AppCardTitle>{translate(STRINGS.REQUIRED_DOCUMENTS)}</AppCardTitle>
      </AppCardHeader>
      <AppCardContent>
        <AppList density="densed" bordered={true}>
          {props.documents.map((document) => (
            <AppListItem
              key={document.name}
              leading={<AppIcon icon={CHEVRON_RIGHT_ICON} fill="gray-200" />}
              title={document.name}
            />
          ))}
        </AppList>
      </AppCardContent>
    </AppCard>
  );
};

export default AvailableTaskRequiredDocuments;
